var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotifyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5938 9.69989C12.2027 9.69989 12.7049 9.94801 12.7049 10.3887V13.9462C12.7049 14.358 12.1735 14.6443 11.5938 14.6443C11.0013 14.6443 10.4938 14.3608 10.4938 13.9462V10.3887C10.4938 9.9456 10.9735 9.69989 11.5938 9.69989ZM11.5938 6.29535C12.2163 6.29535 12.738 6.7591 12.738 7.32914C12.738 7.90016 12.215 8.37398 11.5938 8.37398C10.9638 8.37398 10.4386 7.90221 10.4386 7.32914C10.4386 6.75704 10.9624 6.29535 11.5938 6.29535ZM2.75 10.5888C2.75 5.70352 6.70572 1.75 11.5938 1.75C16.4808 1.75 20.4375 5.70259 20.4375 10.5888C20.4375 14.4508 17.9452 17.8081 14.3533 18.9881L12.4472 21.7977C12.2552 22.0806 11.9356 22.25 11.5938 22.25C11.2519 22.25 10.9323 22.0806 10.7403 21.7977L8.83421 18.9881C5.24274 17.8083 2.75 14.4513 2.75 10.5888ZM11.5938 19.3819L12.8509 17.5289C12.9878 17.3271 13.1918 17.1804 13.4266 17.1147C16.3205 16.3055 18.375 13.657 18.375 10.5888C18.375 6.85258 15.3328 3.8125 11.5938 3.8125C7.85474 3.8125 4.8125 6.85258 4.8125 10.5888C4.8125 13.6561 6.86609 16.3053 9.76084 17.1147C9.99566 17.1803 10.1996 17.3271 10.3366 17.5289L11.5938 19.3819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifyInfo);
export default __webpack_public_path__ + "static/media/icon-notify-info.722a3c23929fdafebfcdceb12d488dc3.svg";
export { ForwardRef as ReactComponent };